export const FormLibVersion = 13;
export const APP_VERSION = 135;
export const APP_NAME = 'Quick Connect Forms';
export const SESSION_ID = 'QC-SessionId';
